import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import rootReducer from "./rootReducer"; // Make sure rootReducer is correctly imported
import storage from "redux-persist/lib/storage"; // Default localStorage

// Fallback for server-side rendering (when localStorage is unavailable)
const createNoopStorage = () => ({
  getItem: () => Promise.resolve(null),
  setItem: () => Promise.resolve(),
  removeItem: () => Promise.resolve(),
});

// Check if we're on the client-side (browser environment)
const storageAvailable =
  typeof window !== "undefined" ? storage : createNoopStorage();

const persistConfig = {
  key: "root",
  storage: storageAvailable, // Use storageAvailable (either localStorage or noop storage)
  whitelist: ["campaign", "task", "common", "customCampaign", "cart"], // List of reducers to persist
};

// Wrap the root reducer with redux-persist
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Redux store with redux-persist middleware
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"], // Ignore redux-persist actions
      },
    }),
});

// Create the persistor for use in PersistGate
export const persistor = persistStore(store);
